export const environment = {
    production: true,
    apiKey: 'Qs3P9uZf29JNEwpnWjgGNFnNvZXT8FuXyDhXEa8bh',
    apiUrls: {
        Dacia: 'https://login.kanava.dacia.fi',
        Renault: 'https://login.kanava.renault.fi',
        Hyundai: 'https://backend.kaistav2.bassadoneservices.com'
    }
};
